const ICONS_VARIANTS = {
  accent: 'var(--text-accent)',
  dark: 'var(--text-secondary)'
}

export default ICONS_VARIANTS
